import { render, staticRenderFns } from "./BoardDetailFaqLayout.vue?vue&type=template&id=513f49a1&scoped=true"
import script from "./BoardDetailFaqLayout.vue?vue&type=script&lang=js"
export * from "./BoardDetailFaqLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f49a1",
  null
  
)

export default component.exports